import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '@Redux/detail/Itineraries';
import { RootState as C_RootState } from '@Redux/common/store';

import ModeBtn from './subComponents/ModeBtn';
import WholeMode from './subComponents/WholeMode';
import ReduceMode from './subComponents/ReduceMode';
import { AirPlane, Bus, Boat, Walk, Train, Cruise } from '@components/Common/Icons';
import styles from './style.module.scss';

const ItineraryDaily = () => {
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);

    const [isWhole, setIsWhole] = useState<boolean>(true);

    const dispatch = useDispatch();

    const trafficIcon: { [key: string]: JSX.Element } = {
        Plan: <AirPlane />,
        Train: <Train />,
        Boats: <Boat />,
        Bus: <Bus />,
        Crs: <Cruise />,
        Walk: <Walk />,
    };

    const mealType = [1, 2, 4, 8, 16, 32];

    const toggleLightBox = (reqDayID: number, reqPOIID: string) => {
        dispatch(actions.setPoi({ DayID: reqDayID, POIID: reqPOIID }));
        dispatch(actions.toggleLightBoxAction());
    };

    return (
        <div className={styles['itinerary_daily']}>
            {curPage !== 'print' && <ModeBtn isWhole={isWhole} setIsWhole={setIsWhole} />}
            {isWhole ? (
                <WholeMode
                    mealType={mealType}
                    trafficIcon={trafficIcon}
                    toggleLightBox={toggleLightBox}
                />
            ) : (
                curPage !== 'print' && (
                    <ReduceMode toggleLightBox={toggleLightBox} mealType={mealType} />
                )
            )}
        </div>
    );
};

export default ItineraryDaily;
